module.exports = __webpack_public_path__ + "static/img/case1.67959aa0.png";